import React from "react";

const Index = () => {
  return (
    <>
      <div className="container content-space-2 content-space-lg-3">
        {/* Heading */}
        <div className="w-md-75 w-lg-50 text-center mx-md-auto mb-5 mb-md-9">
          <h2>The better way to shop with Front top-products</h2>
        </div>
        {/* End Heading */}

        <div className="row mb-2">
          <div className="col-sm-6 col-md-4 mb-4">
            {/* Card */}
            <div className="card card-bordered shadow-none overflow-hidden">
              <div className="card-body d-flex align-items-center border-bottom p-0">
                <div className="w-65 border-end">
                  <img
                    className="img-fluid"
                    src="../assets/img/480x320/img3.jpg"
                    alt=" Description"
                  />
                </div>
                <div className="w-35">
                  <div className="border-bottom">
                    <img
                      className="img-fluid"
                      src="../assets/img/480x320/img8.jpg"
                      alt=" Description"
                    />
                  </div>
                  <img
                    className="img-fluid"
                    src="../assets/img/480x320/img7.jpg"
                    alt=" Description"
                  />
                </div>
              </div>

              <div className="card-footer text-center">
                <h3 className="card-title">T-shirts</h3>
                <p className="card-text text-muted small">
                  Starting from $29.99
                </p>
                <a
                  className="btn btn-outline-primary btn-sm btn-transition rounded-pill px-6"
                  href="#"
                >
                  View all
                </a>
              </div>
            </div>
            {/* End Card */}
          </div>
          {/* End Col */}

          <div className="col-sm-6 col-md-4 mb-4">
            {/* Card */}
            <div className="card card-bordered shadow-none overflow-hidden">
              <div className="card-body d-flex align-items-center border-bottom p-0">
                <div className="w-65 border-end">
                  <img
                    className="img-fluid"
                    src="../assets/img/480x320/img4.jpg"
                    alt=" Description"
                  />
                </div>
                <div className="w-35">
                  <div className="border-bottom">
                    <img
                      className="img-fluid"
                      src="../assets/img/480x320/img6.jpg"
                      alt=" Description"
                    />
                  </div>
                  <img
                    className="img-fluid"
                    src="../assets/img/480x320/img5.jpg"
                    alt=" Description"
                  />
                </div>
              </div>

              <div className="card-footer text-center">
                <h3 className="card-title">Tech covers</h3>
                <p className="card-text text-muted small">
                  Starting from $399.99
                </p>
                <a
                  className="btn btn-outline-primary btn-sm btn-transition rounded-pill px-6"
                  href="#"
                >
                  View all
                </a>
              </div>
            </div>
            {/* End Card */}
          </div>
          {/* End Col */}

          <div className="col-sm-6 col-md-4 mb-4">
            {/* Card */}
            <div className="card card-bordered shadow-none overflow-hidden">
              <div className="card-body d-flex align-items-center border-bottom p-0">
                <div className="w-65 border-end">
                  <img
                    className="img-fluid"
                    src="../assets/img/480x320/img2.jpg"
                    alt=" Description"
                  />
                </div>
                <div className="w-35">
                  <div className="border-bottom">
                    <img
                      className="img-fluid"
                      src="../assets/img/480x320/img4.jpg"
                      alt=" Description"
                    />
                  </div>
                  <img
                    className="img-fluid"
                    src="../assets/img/480x320/img3.jpg"
                    alt=" Description"
                  />
                </div>
              </div>

              <div className="card-footer text-center">
                <h3 className="card-title">Caps</h3>
                <p className="card-text text-muted small">
                  Starting from $13.99
                </p>
                <a
                  className="btn btn-outline-primary btn-sm btn-transition rounded-pill px-6"
                  href="1"
                >
                  View all
                </a>
              </div>
            </div>
            {/* End Card */}
          </div>
          {/* End Col */}
        </div>
        {/* End Row */}

        <div className="text-center">
          <p className="small">Limited time only, while stocks last.</p>
        </div>
      </div>
    </>
  );
};

export default Index;
